export default __webpack_public_path__ + "static/media/Wildness.0f221e1b.jpg";